import { HttpErrorResponse } from "@angular/common/http";
import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
import { Router } from "@angular/router";
import { SnackbarService } from "../../../../components/snackbar/snackbar.service";
import { UserFormComponent } from "../../components/user-form/user-form.component";
import { CreateUserRequest, UserFormValue } from "../../models/user.model";
import { UserApiService } from "../../services/user.api.service";

@Component({
    selector: "app-create-user",
    templateUrl: "./create-user.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [UserFormComponent]
})
export class CreateUserComponent {
    private readonly userService = inject(UserApiService);
    private readonly router = inject(Router);
    private readonly snackbarService = inject(SnackbarService);

    readonly submitting = signal(false);

    onSubmit(value: UserFormValue): void {
        const request: CreateUserRequest = value;

        this.submitting.set(true);
        this.userService.createUser(request).subscribe({
            next: () => {
                this.snackbarService.show("User created.", "success");
                void this.router.navigate(["/admin/users"]);
            },
            error: (error: HttpErrorResponse) => {
                this.submitting.set(false);
                this.snackbarService.show(error.error?.detail ?? "We couldn’t create the user. Try again.", "error");
            }
        });
    }
}
